import React from 'react'
import PropTypes from 'prop-types'

function ChildRow({ images, files, colSpan }) {
  return (
    <td colSpan={colSpan} className="table__child-row">
      <div className="detailed-info detailed-info__images">
        <span className="detailed-info__section-title u-vertical-middle">Images</span>
        <ul className="list--horizontal u-vertical-middle">
          {images.map((image, index) => <li key={index}><img src={image.attributes.imageName.url} /></li>)}
        </ul>
      </div>

      <div className="detailed-info">
        <div className="detailed-info__section-title u-vertical-middle">Files</div>
        <ul className="list--horizontal u-vertical-middle">
          {files.map((file, index) => <li key={index}>{file.attributes.fileName}</li>)}
        </ul>
      </div>
    </td>
  )
}

ChildRow.propTypes = {
  images: PropTypes.array.isRequired,
  files: PropTypes.array.isRequired,
  colSpan: PropTypes.number.isRequired,
}

export default ChildRow
